import { SearchType } from 'components/SearchSideBar/types';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import {
  createConditionQueryObject,
  createQueryUrl,
  createUrl,
  createUsrclkSearchConditionText,
  createUsrclkSearchQuery,
} from '../createSearchResultPageUrl';
import { DEFAULT_PARAMS } from '../../constants';

/**
 * 遷移先URLの生成処理を実行し、検索結果ページに遷移
 *
 * @param {SelectedCurrentConditionType} selectedSearchCondition - 現在選択されている検索条件
 * @param {SearchType} searchType - 検索タイプ
 * @param {boolean} loginStatus - ログイン状態
 * @param {number} oldestDayWdtno - 最古の日付のWDT番号
 * @returns {void} なし
 */
export const moveToSearchResultPage = (
  selectedSearchCondition: SelectedCurrentConditionType,
  searchType: SearchType,
  loginStatus: boolean,
  oldestDayWdtno: number
) => {
  // 計測用の検索条件クエリを生成
  const usrclkSearchCondition = createUsrclkSearchConditionText(
    selectedSearchCondition
  );
  // 計測用クエリを生成
  const usrclk = createUsrclkSearchQuery(
    searchType,
    loginStatus,
    usrclkSearchCondition
  );

  // 検索条件のクエリ文字列を生成
  const searchConditionQuery = createQueryUrl(
    createConditionQueryObject({
      selectedCurrentCondition: selectedSearchCondition,
      oldestDayWdtno: oldestDayWdtno.toString(),
      leftPanelType: '1',
      usrclk,
      defaultParams: DEFAULT_PARAMS,
    })
  );

  const url = createUrl(searchConditionQuery);

  window.location.href = url;
};
